// extracted by mini-css-extract-plugin
export default {"control":"input-number_control__whvRV"};